import { DestroyRef, Directive, inject, TemplateRef } from '@angular/core';
import { DetailDrawerFrame } from './detail-drawer-frame.service';

/**
 * Marks the item's tab list for the drawer to show at the foot of its header, below the title:
 *
 * ```html
 * <ng-template lpDetailDrawerTabs>
 *   <dm-tabs type="underline" …>…</dm-tabs>
 * </ng-template>
 * ```
 *
 * The header drops its own border while an item provides tabs, so the tabs' underline is the
 * header's edge. Which tab is on show belongs in the URL — see {@link injectDetailDrawerTab}. The
 * template keeps the item's own bindings and styles; only where it renders moves.
 */
@Directive({ selector: 'ng-template[lpDetailDrawerTabs]' })
export class DetailDrawerTabsDirective {
  private readonly frame = inject(DetailDrawerFrame);
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);

  constructor() {
    this.frame.showTabs(this.templateRef);
    inject(DestroyRef).onDestroy(() => this.frame.clearTabs(this.templateRef));
  }
}
